// node_modules
import MarkdownIt from "markdown-it";
import StateCore from "markdown-it/lib/rules_core/state_core";
import Token from "markdown-it/lib/token";
// Helpers
import { ReferenceHelperSingleton } from "Helpers";
// Types
import { TOpenReferencePreviewModalCustomEventDetail } from "Types";

const openReferencePreviewModalOnLinkOver = (token: Token, env: any | undefined = undefined): void => {
    // check if the current token & token.attrs is null
    if (!token || !token.attrs) return;

    // only add onmouseover event handler on link to an igor internal data
    // (starting with #)
    let isLinkToIgorInternalData = false;
    for (const attr of token.attrs) {
        if (attr[0] === "href" && attr[1].startsWith("#")) {
            isLinkToIgorInternalData = true;
            break;
        }
    }
    if (!isLinkToIgorInternalData) return;
    
    // Dispatch custom event to open reference preview modal (see ReferenceHelper.ts).
    // Since we are in the rendering phase of the markdown
    // we are manipulating markdown-it token and not HTML DOM Element yet, 
    // so we can't add onmouseover event handler on the current token (upcoming HTML DOM Element) in a trivial way.
    // To do it, we set the onmouseover HTML attribute of the current token
    // with a JavaScript string code which will dispatch a custom event at window as an event target.
    // In the custom event, we add the real target of the onmouseover event as property.
    token.attrPush(["onmouseover", "window.dispatchEvent(new CustomEvent('openReferencePreviewModalCustomEvent', {detail: {target: this}}))"]);
};

// listen for the open reference preview modal custom event
window.addEventListener("openReferencePreviewModalCustomEvent", (openReferencePreviewModalCustomEventInit: CustomEventInit<TOpenReferencePreviewModalCustomEventDetail>) => {
    // safety checks
    if (!openReferencePreviewModalCustomEventInit || 
        !openReferencePreviewModalCustomEventInit.detail || 
        !openReferencePreviewModalCustomEventInit.detail.target ||
        !(openReferencePreviewModalCustomEventInit.detail.target instanceof HTMLAnchorElement)) return;

    // handle open reference preview modal custom event
    ReferenceHelperSingleton.handleOpenReferencePreviewModalCustomEventAsync(openReferencePreviewModalCustomEventInit.detail);
}, false);

export const addOpenReferencePreviewModalOnLinkOverExtension = (markdownIt: MarkdownIt): void => {
    markdownIt.core.ruler.after(
        "markdown-it-modify-link",
        "markdown-it-open-reference-preview-modal-on-link-over",
        (state: StateCore) => {
            state.tokens.forEach((value: Token) => {
                if (value.type === "inline" && value.children) {
                    value.children.forEach((token: Token) => {
                        const type: string = token.type;
                        if (type === "link_open") {
                            openReferencePreviewModalOnLinkOver(token, state.env);
                        }
                    });
                }
            });
            return false;
        }
      );
};